import { render } from "./RecipeWarnings.vue?vue&type=template&id=74c1996e"
import script from "./RecipeWarnings.vue?vue&type=script&lang=js"
export * from "./RecipeWarnings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__